import React from 'react';
import FormModal from '../../Modals/FormModal';
import { useQzTrayConfiguration } from '../../../hooks/qztray/useQzTrayConfiguration';
import { CheckCircle2, XCircle } from 'lucide-react';
import QzTrayTestDetailsCard from '../TestConnection/QzTrayTestDetailsCard';

const QzTrayTestConnectionModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  const { testResult } = useQzTrayConfiguration();

  if (!testResult) return null;
  const isSuccess = testResult.success;

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="🔌 Resultado de la Prueba de Conexión"
      maxWidth="max-w-xl"
    >
      <div className="mt-5 space-y-6">
        {/* 🔷 Estado general */}
        <div
          className={`flex flex-col items-center justify-center gap-2 rounded-xl border px-5 py-5 text-center shadow-sm transition-colors duration-200
          ${
            isSuccess
              ? 'border-green-500 bg-green-100/60 dark:bg-green-900/30'
              : 'border-red-500 bg-red-100/60 dark:bg-red-900/30'
          }`}
        >
          {isSuccess ? (
            <CheckCircle2 className="text-green-500" size={30} />
          ) : (
            <XCircle className="text-red-500" size={30} />
          )}

          <div>
            <h3
              className={`text-lg font-semibold ${
                isSuccess
                  ? 'text-green-700 dark:text-green-400'
                  : 'text-red-700 dark:text-red-400'
              }`}
            >
              {isSuccess ? 'Conexión exitosa' : 'Error en la conexión'}
            </h3>

            <p className="text-gray-600 dark:text-gray-300 mt-1 text-sm">
              {testResult.message ||
                'Se intentó comunicar con el servicio QZ Tray, revise detalles abajo.'}
            </p>
          </div>
        </div>

        {/* 📋 Detalles técnicos */}
        <QzTrayTestDetailsCard
          testedHost={testResult.testedHost}
          testedPort={testResult.testedPort}
          responseTimeMs={testResult.responseTimeMs}
          testedAt={testResult.testedAt}
        />

        {/* ⚙️ Botón de cierre */}
        <div className="flex justify-end pt-2">
          <button
            onClick={onClose}
            className="rounded-lg bg-primary px-6 py-2.5 font-medium text-white shadow-sm transition-colors duration-200 hover:bg-primary/90"
          >
            Cerrar
          </button>
        </div>
      </div>
    </FormModal>
  );
};

export default QzTrayTestConnectionModal;
